"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuGroup = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var config_context_1 = require("../_util/config-context");
exports.MenuGroup = react_1.forwardRef(function MenuGroup(_a, ref) {
    var title = _a.title, children = _a.children, className = _a.className, props = tslib_1.__rest(_a, ["title", "children", "className"]);
    var classPrefix = config_context_1.useConfig().classPrefix;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("li", tslib_1.__assign({ ref: ref, className: classnames_1.default(classPrefix + "-menu__label", className) }, props),
            react_1.default.createElement("a", { className: classPrefix + "-menu__item" },
                react_1.default.createElement("div", { className: classPrefix + "-menu__text" }, title))),
        children));
});
exports.MenuGroup.displayName = "MenuGroup";
//# sourceMappingURL=MenuGroup.js.map